import {
  FETCH_ALL_LISTS_INIT,
  FETCH_ALL_LISTS_SUCCESS,
  FETCH_ALL_LISTS_FAILURE,
  FETCH_ALL_ITEMS_BY_LIST_INIT,
  FETCH_ALL_ITEMS_BY_LIST_SUCCESS,
  FETCH_ALL_ITEMS_BY_LIST_FAILURE,
  ACCOUNT_LIST_RESET_LIST_ITEMS,
  ACCOUNT_LIST_ADD_NEW_ITEM_TO_SAVE_OR_DELETE,
  ACCOUNT_LIST_REMOVE_NEW_ITEM_TO_SAVE_OR_DELETE,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_INIT,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_FAILURE,
  ACCOUNT_LIST_SAVE_ITEMS_CHANGES_SUCCESS,
  ACCOUNT_LIST_CREATE_LIST_INIT,
  ACCOUNT_LIST_CREATE_LIST_SUCCESS,
  ACCOUNT_LIST_CREATE_LIST_FAILURE,
  ACCOUNT_LIST_DELETE_LIST_INIT,
  ACCOUNT_LIST_DELETE_LIST_SUCCESS,
  ACCOUNT_LIST_DELETE_LIST_FAILURE,
  RESET_ACCOUNT_LIST
} from './types';
import API from './api';

// Fetch all categories from the API
function fetchAllListsInit() {
  return {
    type: FETCH_ALL_LISTS_INIT
  };
}

function fetchAllListsSuccess(data) {
  return {
    type: FETCH_ALL_LISTS_SUCCESS,
    payload: data
  };
}

function fetchAllListsFailure(error) {
  return {
    type: FETCH_ALL_LISTS_FAILURE,
    payload: error
  };
}

export function getAllLists(obj) {
  return async dispatch => {
    dispatch(fetchAllListsInit());
    try {
      let data = await API.data.handleGetAllLists(obj);
      dispatch(fetchAllListsSuccess(data));
    } catch (error) {
      dispatch(fetchAllListsFailure(error));
    }
  };
}

 /* Create List (Async) */

function createListApiSuccess(data) {
  return {
    type: ACCOUNT_LIST_CREATE_LIST_SUCCESS,
    payload: data
  };
}

function createListApiFailure(error) {
  return {
    type: ACCOUNT_LIST_CREATE_LIST_FAILURE,
    payload: error
  };
}

function createListApiInit() {
  return {
    type: ACCOUNT_LIST_CREATE_LIST_INIT
  };
}

export function createList(listData) {
  return async dispatch => {
    dispatch(createListApiInit());
    try {
      const resp = await API.data.handleCreateList(listData);
      return dispatch(createListApiSuccess(resp));
    } catch (error) {
      return dispatch(createListApiFailure(error));
    }
  };
}

/* Delete List (Async) */

function deleteListApiSuccess(data) {
  return {
    type: ACCOUNT_LIST_DELETE_LIST_SUCCESS,
    payload: data
  };
}

function deleteListApiFailure(error) {
  return {
    type: ACCOUNT_LIST_DELETE_LIST_FAILURE,
    payload: error
  };
}

function deleteListApiInit() {
  return {
    type: ACCOUNT_LIST_DELETE_LIST_INIT
  };
}

export function deleteList(listData) {
  return async dispatch => {
    dispatch(deleteListApiInit());
    try {
      const resp = await API.data.handleDeleteList(listData);
      return dispatch(deleteListApiSuccess(resp));
    } catch (error) {
      return dispatch(deleteListApiFailure(error));
    }
  };
}

// Get items by list
function fetchAllItemsByListInit() {
  return {
    type: FETCH_ALL_ITEMS_BY_LIST_INIT
  };
}

function fetchAllItemsByListSuccess(data,selectedList) {
  return {
    type: FETCH_ALL_ITEMS_BY_LIST_SUCCESS,
    payload: {
      data: data,
      selectedList: selectedList
    }
  };
}

function fetchAllItemsByListFailure(error) {
  return {
    type: FETCH_ALL_ITEMS_BY_LIST_FAILURE,
    payload: error
  };
}

export function getAllItemsByList(listId, listName) {
  return async dispatch => {
    dispatch(fetchAllItemsByListInit());
    try {
      let data = await API.data.handleGetAllItemsByList(listId);
      dispatch(fetchAllItemsByListSuccess(
        data,
        {listId: listId, listName: listName}
      ));
    } catch (error) {
      dispatch(fetchAllItemsByListFailure(error));
    }
  };
}

export function handleResetListItems() {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_LIST_RESET_LIST_ITEMS
    });
  };
}

/* Item */
export function addNewItemToSaveOrDelete(item) {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_LIST_ADD_NEW_ITEM_TO_SAVE_OR_DELETE,
      payload: item
    });
  };
}

export function removeNewItemToSaveOrDelete(item) {
  return dispatch => {
    return dispatch({
      type: ACCOUNT_LIST_REMOVE_NEW_ITEM_TO_SAVE_OR_DELETE,
      payload: item
    });
  };
}

function saveItemsChangesInit() {
  return {
    type: ACCOUNT_LIST_SAVE_ITEMS_CHANGES_INIT
  };
}

function saveItemsChangesSuccess(data) {
  return {
    type: ACCOUNT_LIST_SAVE_ITEMS_CHANGES_SUCCESS,
    payload: data
  };
}

function saveItemsChangesFailure(error) {
  return {
    type: ACCOUNT_LIST_SAVE_ITEMS_CHANGES_FAILURE,
    payload: error
  };
}

export function saveItemsChanges(items) {
  return async dispatch => {
    dispatch(saveItemsChangesInit());
    try {
      let data = await API.data.handleSaveItemsChanges(items);
      dispatch(saveItemsChangesSuccess(data));
    } catch (error) {
      dispatch(saveItemsChangesFailure(error));
    }
  };
}

//reset
export function resetAccountList() {
  return dispatch => {
    return dispatch({
      type: RESET_ACCOUNT_LIST
    });
  };
}



// WEBPACK FOOTER //
// ./source/client/actions/account_list/index.js